import "./styles.less";
import "moment/locale/es";

import { Calendar, Col, Row, Space, Typography } from "antd";
import React, { FC } from "react";

import { CustomCell } from "./CustomCell/web";
import { CustomHeader } from "./CustomHeader/web";
import locale from "antd/lib/date-picker/locale/es_ES";
import moment from "moment";
import { useAvailabilityCalendar } from "./hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { OccupancyType } from "shared-components";

moment.locale("es");

interface AvailabilityCalendarProps {
	occupancies: OccupancyType[];
}

export const AvailabilityCalendar: FC<AvailabilityCalendarProps> = ({ occupancies }) => {
	const {
		firstMonth,
		secondMonth,
		nextMonth,
		prevMonth,
		occupanciesList,
	} = useAvailabilityCalendar({
		occupancies,
	});
	const { theme } = useTheme();

	return (
		<Row
			className="availability-calendar"
			gutter={[theme.spacing.xxlSpacing, theme.spacing.lgSpacing]}>
			<Col xs={24} md={12}>
				<Calendar
					locale={locale}
					className="availability-calendar"
					value={firstMonth}
					fullscreen={false}
					headerRender={() => <CustomHeader month={firstMonth} prevMonth={prevMonth} />}
					dateFullCellRender={date => (
						<CustomCell date={date} month={firstMonth} occupancies={occupanciesList} />
					)}
					disabledDate={(current) => {
						let customDate = moment().format("YYYY-MM-DD");
						return current && current < moment(customDate, "YYYY-MM-DD");
					}}
				/>
			</Col>
			<Col xs={24} md={12}>
				<Calendar
					locale={locale}
					className="availability-calendar"
					value={secondMonth}
					fullscreen={false}
					headerRender={() => <CustomHeader month={secondMonth} nextMonth={nextMonth} />}
					dateFullCellRender={date => (
						<CustomCell date={date} month={secondMonth} occupancies={occupanciesList} />
					)}
					disabledDate={(current) => {
						let customDate = moment().format("YYYY-MM-DD");
						return current && current < moment(customDate, "YYYY-MM-DD");
					}}
				/>
			</Col>

			<Col span={24}>
				<div style={{ textAlign: "center" }}>
					<Space size="middle">
						<Space>
							<div className="available-box"></div>
							<Typography>Disponible</Typography>
						</Space>
						<Space>
							<div className="available-box no-available-box"></div>
							<Typography>No Disponible</Typography>
						</Space>
					</Space>
				</div>
			</Col>
		</Row>
	);
};
